import { environment } from "../environments/environment";

export const userReadWriteGroups = {
  DLI: environment.readWriteGroups, // SJP-AmigoWeb-ReadWrite
  CONTACT: environment.readWriteContactsGroups, // Amigo Trafikledning Admin
  TRAIN_ORDERS: environment.trainOrderGroups, // Train Orders Access
  ALCOLOCK: environment.alcolockGroups, // Alcolock access users
  DRIVER_DEVIATION: environment.driverDeviationGroups // Driver Deviation access users
};
// If empty, assume all have read access
export const userReadGroups = {
};
